import { ROUTES_NAMES } from '@/constants';
import store from '@/store';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export const beforeEnterLogoutRoute = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void => {
  const clientId = to.query.client_id;
  const redirectURI = to.query.redirect_uri;

  if (!clientId || !redirectURI) {
    return next({ name: ROUTES_NAMES.error });
  }

  store.dispatch('setClientID', clientId);
  store.dispatch('setRedirectURI', redirectURI);
  next();
};
